module.exports = __webpack_public_path__ + "img/faqPositive.3cb96ae1.svg";